import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana22Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1467_38254)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M789.047 286.861L773.383 337.333L731.613 342.555L722.911 274.678C733.354 272.358 757.719 267.717 771.643 267.717C785.566 267.717 789.047 280.48 789.047 286.861Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("23"))}      
      d="M759.451 398.245L773.375 337.33L700.277 347.773L712.46 413.908C721.162 413.328 740.307 411.82 747.269 410.427C754.23 409.035 758.291 401.725 759.451 398.245Z" 
      fill={getFillByLot(23, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("2"))}      
      d="M667.214 286.86L722.908 274.677L731.61 342.553L679.397 351.255L667.214 286.86Z" 
      fill={getFillByLot(2, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("22"))}      
      d="M658.512 426.092L712.465 413.909L700.282 347.773L641.108 361.697L658.512 426.092Z" 
      fill={getFillByLot(22, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("3"))}      
      d="M611.521 300.783L667.215 286.859L679.398 352.995L627.185 365.178L611.521 300.783Z" 
      fill={getFillByLot(3, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("21"))}      
      d="M604.559 440.017L658.512 426.094L641.108 361.698L583.674 377.362L604.559 440.017Z" 
      fill={getFillByLot(21, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("4"))}      
      d="M557.566 316.447L611.519 300.783L627.183 365.178L574.971 379.102L557.566 316.447Z" 
      fill={getFillByLot(4, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("20"))}      
      d="M552.347 459.163L604.56 440.018L583.675 377.363L527.981 396.508L552.347 459.163Z" 
      fill={getFillByLot(20, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("5"))}      
      d="M501.878 335.591L557.571 316.446L574.975 379.101L524.503 398.246L501.878 335.591Z" 
      fill={getFillByLot(5, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("19"))}      
      d="M500.138 481.787L552.35 459.162L527.984 396.507L472.291 419.132L500.138 481.787Z" 
      fill={getFillByLot(19, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("6"))}      
      d="M449.663 356.477L501.875 335.592L524.5 398.247L475.769 417.391L449.663 356.477Z" 
      fill={getFillByLot(6, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("7"))}      
      d="M399.191 380.841L449.663 356.476L475.77 417.39L425.298 441.756L399.191 380.841Z" 
      fill={getFillByLot(7, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("18"))}      
      d="M447.923 506.153L500.135 481.788L472.289 419.133L418.336 445.239L447.923 506.153Z" 
      fill={getFillByLot(18, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("8"))}      
      d="M348.72 406.946L399.192 380.84L425.298 441.754L378.307 466.12L348.72 406.946Z" 
      fill={getFillByLot(8, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("17"))}      
      d="M397.454 532.26L447.926 506.154L418.339 445.239L366.127 473.086L397.454 532.26Z" 
      fill={getFillByLot(17, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("9"))}      
      d="M299.988 433.057L348.72 406.951L378.307 466.125L329.575 492.231L299.988 433.057Z" 
      fill={getFillByLot(9, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("16"))}      
      d="M345.241 560.108L397.454 532.261L366.126 473.087L315.654 499.193L345.241 560.108Z" 
      fill={getFillByLot(16, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("15"))}      
      d="M293.025 586.21L345.237 560.104L315.65 499.189L263.438 527.036L293.025 586.21Z" 
      fill={getFillByLot(15, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("10"))}      
      d="M251.255 457.419L299.986 433.053L329.573 492.227L280.842 518.333L251.255 457.419Z" 
      fill={getFillByLot(10, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("11"))}      
      d="M202.525 483.528L251.257 457.422L280.844 518.336L230.372 544.443L202.525 483.528Z" 
      fill={getFillByLot(11, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("14"))}      
      d="M240.812 612.318L293.025 586.212L263.438 527.038L212.966 553.144L240.812 612.318Z" 
      fill={getFillByLot(14, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("12"))}      
      d="M162.496 502.672L202.526 483.527L230.372 544.442L171.198 574.029L162.496 502.672Z" 
      fill={getFillByLot(12, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("13"))}      
      d="M174.679 622.761L171.198 574.029L212.968 553.145L240.815 612.319L190.343 636.684C180.596 639.469 175.839 628.562 174.679 622.761Z" 
      fill={getFillByLot(13, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1467_38254" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1467_38254" transform="matrix(0.00238727 0 0 0.00316488 -4.56218 -1.41832)"/>
    </pattern>
    <image id="image0_1467_38254"  width="4096" height="2304" href="/mz2.png"/>
    </defs>
  </svg>
  );
};